export const HOME_PAGE = "hmovies";
